import React from "react";
import { Spinner as BootstrapSpinner } from "react-bootstrap";
import { ISpinnerProps } from "../../interfaces/Components/Spinner/ISpinnerProps";

export const Spinner : React.FC<ISpinnerProps> = ({ visible, spinnerText, ...props }) => (
  <>
    {visible && (
      <BootstrapSpinner {...props} role="status" size="sm">
        <span className="visually-hidden">
          {spinnerText}
          ...
        </span>
      </BootstrapSpinner>
    )}
  </>
);
